import { render, staticRenderFns } from "./PostContentAction.vue?vue&type=template&id=b03bbd7a"
import script from "./PostContentAction.vue?vue&type=script&lang=js"
export * from "./PostContentAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports